/**
=========================================================
* E4A-IoT-Manager React Frontend Dashboard 
* Copyright © 2024 Electronics4All Inc.
=========================================================
*/

// @mui material components
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export default styled(Box)(({ theme, ownerState }) => {
  const { palette, typography, borders, functions } = theme;
  const { darkMode } = ownerState;

  const { text, white, dark, inputBorderColor, transparent, error } = palette;
  const { size } = typography;
  const { borderRadius, borderWidth } = borders;
  const { rgba } = functions;

  return {
    display: "flex",
    alignItems: "center",
    border: `${borderWidth[1]} solid ${inputBorderColor} !important`,
    borderRadius: borderRadius.md,

    "&.dropzone": {
      background: `${transparent.main} !important`,
    },

    "& .dz-default": {
      margin: "0 auto !important",
    },

    "& .dz-default .dz-button": {
      color: `${text.main} !important`,
      fontSize: `${size.sm} !important`,
    },

    "& .dz-preview.dz-image-preview": {
      background: `${transparent.main} !important`,
    },

    "& .dz-preview .dz-filename": {
      // Fixed double $ typo; ensure proper color assignment
      color: `${darkMode ? white.main : dark.main} !important`,
      opacity: "1 !important",
      fontSize: `${size.sm} !important`,

      "& .dz-size span, & .dz-filename span": {
        backgroundColor: `${rgba(white.main, 0.7)} !important`,
      },
    },
    "& .dz-preview .dz-size": {
      // Fixed double $ typo; ensure proper color assignment
      color: `${darkMode ? white.main : dark.main} !important`,
      opacity: "1 !important",
      fontSize: `${size.sm} !important`,

      "& .dz-size span, & .dz-filename span": {
        backgroundColor: `${rgba(white.main, 0.7)} !important`,
      },
    },
    "& .dz-preview .dz-details": {
      color: `${text.main} !important`,
      opacity: "1 !important",

      "& .dz-size span, & .dz-filename span": {
        backgroundColor: `${rgba(white.main, 0.7)} !important`,
      },
    },
    "& .dz-error-message": {
      display: "none !important",
    },

    "& .dz-remove": {
      // Styled as a subtle destructive-text button
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 10px",
      marginTop: "6px",
      fontSize: `${size.sm} !important`,
      lineHeight: 1.2,
      fontWeight: 500,
      color: `${error.main} !important`,
      backgroundColor: `${rgba(error.main, 0.08)} !important`,
      border: `1px solid ${rgba(error.main, 0.4)}`,
  // Increase radius for a pill-like appearance
  borderRadius: 9999,
      textDecoration: "none !important",
      cursor: "pointer",
      userSelect: "none",
      transition: "background-color .15s ease, color .15s ease, box-shadow .15s ease, transform .15s ease",
      boxShadow: "none",

      '&:hover, &:focus': {
        backgroundColor: `${rgba(error.main, 0.15)} !important`,
        color: `${error.dark || error.main} !important`,
        transform: "translateY(-1px)",
        outline: "none",
      },
      '&:active': {
        transform: "translateY(0)",
        backgroundColor: `${rgba(error.main, 0.22)} !important`,
      },
      '&:focus-visible': {
        boxShadow: `0 0 0 3px ${rgba(error.main, 0.3)}`,
      },
    },
  };
});
